import { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import Delete from "./../../../assets/delete.svg";
import Edit from "./../../../assets/edit-user.svg";
import api from "../../../utils/api";
import SwitchButton from "../../../components/SwitchButton/SwitchButton";
import { message } from "antd";
import usePermissions from "../../../hooks/usePermissions";

const SizesGrid = ({ query, onEdit, onDelete, refreshTrigger }) => {
  const { hasPermission } = usePermissions();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);

  const getData = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page + 1,
        limit: pageSize,
        type: "size",
      });

      if (query.length >= 2) {
        params.append("search", query);
      }

      const res = await api.get(`/variations?${params.toString()}`);
      setData(res.data.data);
      setTotalRows(res.data.total || 0);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (query.length >= 2 || query.length === 0) {
        getData();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [query, page, pageSize, refreshTrigger]);

  const handleActive = async (row) => {
    setLoading(true);
    try {
      await api.put(`/variations/${row.id}`, {
        active: row.active === 1 ? 0 : 1,
      });
      getData();
      message.success("تم تعديل الحالة بنجاح");
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const actionColumn = [
    {
      field: "index",
      headerName: "#",
      width: 40,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "name_ar",
      headerName: "الاسم",
      width: 160,
      headerAlign: "center",
      align: "center",
    },
    hasPermission(89) && {
      field: "status",
      headerName: "الحالة",
      flex: 1,
      headerAlign: "right",
      align: "left",
      renderCell: (params) => {
        const isActive = params?.row?.active === 1;
        return (
          <SwitchButton
            checked={isActive}
            onClick={() => handleActive(params.row)}
          />
        );
      },
    },
    {
      field: "action",
      headerName: "",
      width: 160,
      headerAlign: "center",
      align: "center",

      renderCell: (params) => {
        return (
          <div className="cell-action">
            {hasPermission(90) && (
              <div className="cell-btn" onClick={() => onEdit(params.row)}>
                <img src={Edit} alt="" />
              </div>
            )}
            {hasPermission(191) && (
              <div className="cell-btn" onClick={() => onDelete(params.row)}>
                <img src={Delete} alt="" />
              </div>
            )}
          </div>
        );
      },
    },
  ];

  const handlePaginationModelChange = (model) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  };

  return (
    <DataGrid
      sx={{ backgroundColor: "white", width: "100%" }}
      autoHeight={true}
      columns={actionColumn}
      rows={data.map((row, index) => ({
        ...row,
        index: page * pageSize + index + 1,
      }))}
      disableVirtualization
      disableColumnFilter
      disableColumnMenu
      loading={loading}
      paginationMode="server"
      rowCount={totalRows}
      pageSizeOptions={[10, 25, 50]}
      paginationModel={{
        page,
        pageSize,
      }}
      onPaginationModelChange={handlePaginationModelChange}
    />
  );
};

export default SizesGrid;
